<template>
  <div class="hello">
    <div class="centerContainer">
      <h1>Hello,</h1>
      <h2>I'm Gil</h2>
      <p>
          Backend and iOS engineer,<br />manager, and data fanatic
      </p>
      <br />
      <a href="https://www.linkedin.com/in/gilfeig/">
        <img class="socialIcon" src="../assets/linkedin-logo.png">
      </a>
      <!-- <p>
        <ul>
          <li>Head of Engineering @ <a href="https://www.jumpstart.me" target="_blank">Jumpstart</a></li>
          <ul>
            <li>Manage the engineering team</li>
            <li>Lead and develop our Django backend architecture and API in Python</li>
            <li>Build Jumpstart's iOS mobile apps in Swift</li>
            <li>Create and maintain all data visualization dashboards and reports with Looker</li>
            <li>Prioritize tasks and translate priorities for the engineering organization</li>
          </ul>
          <li>Previously, iOS Engineer at LinkedIn and Wealthfront</li>
        </ul>
      </p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextSection'
}
</script>

<style scoped>
.centerContainer {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.socialIcon {
  width: 40px;
  height: 40px;
}

.hello {
  position: relative;
  text-align: left;
  padding-left: 5%;
  flex-grow: 2;
}

h1 {
  font-size: 75px;
  font-weight: lighter;
  margin: 0;
}

h2 {
  font-size: 75px;
  font-weight: bold;
  margin: 0;
}

h3 {
  margin: 20px 0 0;
}

a {
  color: #42b983;
}

p {
  margin: 10px 0;
}

@media only screen and (max-width: 800px) {
  h1 {
    font-size: 40px;
    font-weight: lighter;
    margin: 0;
  }

  h2 {
    font-size: 40px;
    font-weight: bold;
    margin: 0;
  }
}

@media only screen and (max-width: 800px) {
  .centerContainer {
    position: relative;
    padding-bottom: 20px;
    padding-top: 30px;
  }
}
</style>
